import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { STATIC_STRINGS } from "../../../utils/Constants";
import { formatDateTime } from "../../../utils";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import EditIcon from "@mui/icons-material/Edit";
import LinkIcon from "@mui/icons-material/Link";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import Tooltip from "@mui/material/Tooltip";

const RenderHeader = ({ data, assessmentId }: any) => {
  const navigate = useNavigate();

  return (
    <div className="report-header-container">
      <div className="col-12 pb-4">
        <button
          className="cursor-pointer text-neutral-dark p-1 font-medium"
          onClick={() => navigate(-1)}
        >
          <ArrowBackIcon /> {STATIC_STRINGS.BACK}
        </button>
      </div>
      <div className="footer col-12"></div>
      <div className="col-6 row py-4 ">
        <div className="col-12 text-4xl font-bold">{data.name}</div>
        <div className="col-12">
          <div className="p-4 text-lg font-medium text-textColor-subtitle flex items-center">
            <AccessTimeIcon />
            {formatDateTime(data.assessmentLinkActiveDuration.startTime)} -
            {formatDateTime(data.assessmentLinkActiveDuration.endTime)}
          </div>
        </div>
      </div>
      <div className="col-6 row gap-4 justify-end py-4">
        <Tooltip title={STATIC_STRINGS.TOOLTIP_MESSAGES.DOWNLOAD_REPORT}>
          <button className="btn btn-primary h-12 w-12 p-1 flex items-center justify-center ">
            <FileDownloadIcon fontSize="medium" />
          </button>
        </Tooltip>
        <Tooltip title={STATIC_STRINGS.TOOLTIP_MESSAGES.ADD_CANDIDATES}>
          <button
            className="btn btn-outline h-12 w-12 p-1 flex items-center justify-center text-neutral-dark"
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/edit/${assessmentId}?step=5`);
            }}
          >
            <PersonAddAltIcon fontSize="medium" />
          </button>
        </Tooltip>
        <Tooltip title={STATIC_STRINGS.TOOLTIP_MESSAGES.EDIT_ASSESSMENT}>
          <button
            className="btn btn-outline h-12 w-12 p-1 flex items-center justify-center text-neutral-dark"
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/edit/${assessmentId}`);
            }}
          >
            <EditIcon fontSize="medium" />
          </button>
        </Tooltip>
        <Tooltip title={STATIC_STRINGS.TOOLTIP_MESSAGES.COPY_ASSESSMENT_LINK}>
          <button className="btn btn-outline h-12 w-12 p-1 flex items-center justify-center text-neutral-dark">
            <LinkIcon fontSize="medium" />
          </button>
        </Tooltip>
        {/* + tooltip */}
        <button className="btn btn-outline h-12 w-48 p-1 flex items-center justify-center text-neutral-dark">
          <TimerOutlinedIcon fontSize="medium" className="mx-2" />{" "}
          <span>{STATIC_STRINGS.COMPLETED}</span>
        </button>
      </div>
    </div>
  );
};

export default RenderHeader;
